import MuiTextField, { TextFieldProps } from '@mui/material/TextField';
import React, { ReactNode } from 'react';

import { InputBaseProps } from '@mui/material/InputBase';

export type CustomTextFieldProps = TextFieldProps &
  InputBaseProps & {
    helperText?: ReactNode;
  };

const TextField: React.FC<CustomTextFieldProps> = ({ variant = 'outlined', label, InputLabelProps, slotProps, ...rest }) => {
  // Support both deprecated InputLabelProps and new slotProps API (MUI v6+)
  // Priority: slotProps > InputLabelProps (for backward compatibility)
  let muiProps: { slotProps?: typeof slotProps; InputLabelProps?: typeof InputLabelProps } = {};

  if (slotProps) {
    // Use new slotProps API, merge with InputLabelProps if provided
    muiProps.slotProps = {
      ...slotProps,
      inputLabel: {
        ...slotProps.inputLabel,
        ...(InputLabelProps || {})
      }
    };
  } else if (InputLabelProps) {
    // Fallback to deprecated InputLabelProps for backward compatibility
    muiProps.InputLabelProps = InputLabelProps;
  }

  return <MuiTextField variant={variant} label={label} {...muiProps} {...rest} />;
};

export default TextField;
